var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('td',[_c('div',{staticClass:"m-auto h-2/4 w-0 border-l-2 border-solid border-[#5B7185]",class:{}}),_vm._v(" "),_c('v-icon',{staticClass:"w-[24px] m-auto",staticStyle:{"display":"block"},attrs:{"color":_setup.item.severity && _setup.item.severityReason ? 'success' : 'primary'}},[_vm._v("\n      "+_vm._s(_setup.item.severity && _setup.item.severityReason
          ? 'mdi-check-circle'
          : 'mdi-circle')+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"m-auto h-2/4 w-0 border-l-2 border-solid border-[#5B7185]",class:{}})],1),_vm._v(" "),_c('td',[_vm._v("Severity Pre-assessment")]),_vm._v(" "),_c('td',[_vm._v("\n    "+_vm._s(_vm.$t(_setup.rating2scaleLabel(_setup.item.severity) || '-'))+"\n    "),(!_setup.editing)?_c('v-btn',{attrs:{"icon":"","small":"","disabled":_setup.disabled},on:{"click":() => {
          _setup.editing = !_setup.editing
        }}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-pencil")])],1):_vm._e(),_vm._v(" "),(_setup.item.severity)?_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":() => {
          _setup.updateIRO({
            iro: {
              id: _setup.item.id,
              severity: null,
              severityReason: '',
            },
          }).then(() => {
            _setup.editing = true
          })
        }}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-reload")])],1):_vm._e()],1),_vm._v(" "),_c('td',[_c('v-row',[(_setup.editing)?_c('span',{staticClass:"ml-4 mt-4"},[_vm._v("\n        "+_vm._s(_setup.item.type === _setup.EnumIroType.NegativeImpact
            ? _vm.$t('instructionNegative')
            : _vm.$t('instructionPositive'))+"\n      ")]):_c('span',{staticClass:"ml-4 mt-4"},[_vm._v(_vm._s(_setup.item.severityReason))])]),_vm._v(" "),(_setup.editing)?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('ix-btn-toggle-scale5',{attrs:{"value":_setup.item.severity,"rounded":""},on:{"change":(val) => {
              _setup.updateIRO({
                iro: {
                  id: _setup.item.id,
                  severity: val,
                },
              })
            }}})],1)],1):_vm._e(),_vm._v(" "),(_setup.editing)?_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('ix-form-input-text-master',{attrs:{"value":_setup.item.severityReason,"title":_vm.$t('explainTitle'),"is-mandatory":true,"use-text-area":true},on:{"input":(val) => {
              _setup.updateIRO({
                iro: {
                  id: _setup.item.id,
                  severityReason: val,
                },
              })
            }}})],1),_vm._v(" "),_c('v-col',[_c('v-btn',{staticClass:"mt-[55px]",attrs:{"color":"primary","disabled":!(_setup.item.severityReason && _setup.item.severity != null)},on:{"click":() => {
              _setup.editing = false
            }}},[_vm._v("\n          "+_vm._s(_vm.$t('btnDone'))+"\n        ")])],1)],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }